module.exports = __webpack_public_path__ + "static/media/slideshow-36.7d43b73c.jpeg";